import React, { FC } from 'react';
import { ArrowTop, ArrowBottom, ArrowRight, ArrowLeft } from './Arrow';

export type IconFC<T = unknown> = FC<React.SVGProps<SVGSVGElement> & T>;
export type ImgIconFC<T = unknown> = FC<React.ImgHTMLAttributes<HTMLImageElement> & T>;

/** 宽高一致的icon可以直接设置size */
export type RectIconFC = IconFC<{ size?: number; width?: number; height?: number }>;

/** 关闭icon */
export const IconClose: RectIconFC = ({ size = 24, ...rest }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...rest}>
      <path
        d='M5.03412 5.03412C5.36606 4.70217 5.90425 4.70217 6.2362 5.03412L18.9654 17.7633C19.2973 18.0952 19.2973 18.6334 18.9654 18.9654C18.6334 19.2973 18.0952 19.2973 17.7633 18.9654L5.03412 6.2362C4.70217 5.90425 4.70217 5.36606 5.03412 5.03412Z'
        fill='currentColor'
      />
      <path
        d='M18.9659 5.03412C18.6339 4.70217 18.0957 4.70217 17.7638 5.03412L5.03464 17.7633C4.70269 18.0952 4.70269 18.6334 5.03464 18.9654C5.36658 19.2973 5.90477 19.2973 6.23672 18.9654L18.9659 6.2362C19.2978 5.90425 19.2978 5.36606 18.9659 5.03412Z'
        fill='currentColor'
      />
    </svg>
  );
};

/** 右箭头icon */
export const IconRightArrow: IconFC<{ classname?: string }> = ({
  width = 8,
  height = 14,
  fill = 'white',
  classname = '',
  ...rest
}) => {
  return (
    <svg
      className={classname}
      width={width}
      height={height}
      viewBox='0 0 8 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.92792 6.92595C7.96807 6.96729 7.96806 7.03306 7.92791 7.0744L1.81996 13.3633C1.48138 13.7119 0.921716 13.7118 0.583175 13.3632C0.25837 13.0287 0.258397 12.4966 0.583236 12.1621L5.59685 7L0.584056 1.83779C0.259239 1.50329 0.259273 0.971142 0.584135 0.636685C0.922713 0.288106 1.48235 0.288145 1.82088 0.636771L7.92792 6.92595Z'
        fill={fill}
      />
    </svg>
  );
};

/** 左箭头icon */
export const IconLeftArrow: IconFC = ({ width = 8, height = 14, fill = 'white', ...rest }) => {
  return (
    <svg width={width} height={height} viewBox='0 0 8 14' fill='none' xmlns='http://www.w3.org/2000/svg' {...rest}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.0720797 6.92595C0.0319343 6.96729 0.0319376 7.03306 0.0720868 7.0744L6.18004 13.3633C6.51862 13.7119 7.07828 13.7118 7.41683 13.3632C7.74163 13.0287 7.7416 12.4966 7.41676 12.1621L2.40315 7L7.41594 1.83779C7.74076 1.50329 7.74073 0.971142 7.41587 0.636685C7.07729 0.288106 6.51765 0.288145 6.17912 0.636771L0.0720797 6.92595Z'
        fill={fill}
      />
    </svg>
  );
};

/** 减号icon，用于列表收起 */
export const IconMinus: IconFC = ({ width = 12, height = 2, ...rest }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <rect
        x='1'
        y='0.444336'
        width='10'
        height='1.11111'
        rx='0.555556'
        fill='#262629'
        stroke='#262629'
        strokeWidth='0.2'
      />
    </svg>
  );
};

/** 加号icon，用于列表展开 */
export const IconPlus: RectIconFC = ({ size = 12, ...rest }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <rect
        x='1'
        y='5.44434'
        width='10'
        height='1.11111'
        rx='0.555556'
        fill='#262629'
        stroke='#262629'
        strokeWidth='0.2'
      />
      <rect
        x='6.55566'
        y='1'
        width='10'
        height='1.11111'
        rx='0.555556'
        transform='rotate(90 6.55566 1)'
        fill='#262629'
        stroke='#262629'
        strokeWidth='0.2'
      />
    </svg>
  );
};

/** 向下箭头 */
export const IconArrowDown: IconFC = ({ height = 24, width = 14, ...rest }) => {
  return (
    <svg width={width} height={height} viewBox='0 0 12 7' fill='none' xmlns='http://www.w3.org/2000/svg' {...rest}>
      <path
        d='M1.0915 1.84003C0.886476 1.64816 0.886476 1.33708 1.0915 1.14521C1.29653 0.953338 1.62894 0.953339 1.83396 1.14521L6 5.04395L10.166 1.14521C10.3608 0.962933 10.6706 0.953819 10.8768 1.11787L10.9085 1.14521C11.1135 1.33708 11.1135 1.64816 10.9085 1.84003L6.57747 5.89317C6.25854 6.19164 5.74146 6.19164 5.42253 5.89317L1.0915 1.84003Z'
        fill='#262629'
        stroke='#262629'
        strokeWidth='0.4'
      />
    </svg>
  );
};

/** 打勾icon */
export const IconCorrect: RectIconFC = ({ size = 21, ...rest }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={size} height={size} viewBox='0 0 21 21' fill='none' {...rest}>
      <path
        d='M3.42932 9.43359L8.14337 14.1476C8.30608 14.3103 8.5699 14.3103 8.73262 14.1476L17.5715 5.30887'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
      ></path>
    </svg>
  );
};

/** 带圆形背景的关闭icon */
export const IconCloseCircle: RectIconFC = ({ size = 14, ...rest }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg' {...rest}>
      <rect y='0.00195312' width='14' height='14' rx='7' fill='black' />
      <path d='M9.25958 4.76104L4.75368 9.25514' stroke='white' strokeLinecap='round' />
      <path d='M4.75021 4.75223L9.25021 9.25223' stroke='white' strokeLinecap='round' />
    </svg>
  );
};

/** 搜索放大镜 */
export const IconSearch: RectIconFC = ({ size = 24, ...rest }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg' {...rest}>
      <path
        d='M20.2917 20.9587L24.375 25.042'
        stroke='#27272A'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M14.6668 8C10.6167 8 7.3335 11.2832 7.3335 15.3333C7.3335 19.3834 10.6167 22.6667 14.6668 22.6667C18.7169 22.6667 22.0002 19.3834 22.0002 15.3333C22.0002 11.2832 18.7169 8 14.6668 8Z'
        stroke='#27272A'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

/** 带把的箭头icon */
export const IconStickRightArrow: IconFC = ({ width = 20, height = 16, fill, ...rest }) => {
  return (
    <svg width={width} height={height} viewBox='0 0 20 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...rest}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.793 2.20711C11.4024 1.81658 11.4024 1.18342 11.793 0.792893C12.1835 0.402369 12.8167 0.402369 13.2072 0.792893L19.3536 6.93934C19.9394 7.52513 19.9394 8.47487 19.3536 9.06066L13.2072 15.2071C12.8167 15.5976 12.1835 15.5976 11.793 15.2071C11.4024 14.8166 11.4024 14.1834 11.793 13.7929L16.5859 8.99997H1.25032C0.698036 8.99997 0.25032 8.55225 0.25032 7.99997C0.25032 7.44768 0.698036 6.99997 1.25032 6.99997H16.5858L11.793 2.20711Z'
        fill={fill || 'currentColor'}
      />
    </svg>
  );
};
/** 手机 */
export const IconPhone: RectIconFC = ({ size = 18, ...rest }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg' {...rest}>
      <path
        d='M4.875 17.25C4.575 17.25 4.3125 17.1375 4.0875 16.9125C3.8625 16.6875 3.75 16.425 3.75 16.125V1.875C3.75 1.575 3.8625 1.3125 4.0875 1.0875C4.3125 0.8625 4.575 0.75 4.875 0.75H13.125C13.425 0.75 13.6875 0.8625 13.9125 1.0875C14.1375 1.3125 14.25 1.575 14.25 1.875V16.125C14.25 16.425 14.1375 16.6875 13.9125 16.9125C13.6875 17.1375 13.425 17.25 13.125 17.25H4.875ZM9 15.8438C9.1625 15.8438 9.29688 15.7906 9.40312 15.6844C9.50937 15.5781 9.5625 15.4438 9.5625 15.2812C9.5625 15.1187 9.50937 14.9844 9.40312 14.8781C9.29688 14.7719 9.1625 14.7188 9 14.7188C8.8375 14.7188 8.70312 14.7719 8.59687 14.8781C8.49062 14.9844 8.4375 15.1187 8.4375 15.2812C8.4375 15.4438 8.49062 15.5781 8.59687 15.6844C8.70312 15.7906 8.8375 15.8438 9 15.8438ZM4.875 13.3125H13.125V3.5625H4.875V13.3125Z'
        fill='currentColor'
      />
    </svg>
  );
};

/** email */
export const IconEmail: RectIconFC = ({ size = 18, ...rest }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg' {...rest}>
      <path
        d='M3.04999 14.6C2.77 14.6 2.525 14.495 2.315 14.285C2.105 14.075 2 13.83 2 13.55V4.45002C2 4.17002 2.105 3.92502 2.315 3.71502C2.525 3.50502 2.77 3.40002 3.04999 3.40002H14.9499C15.2299 3.40002 15.4749 3.50502 15.6849 3.71502C15.8949 3.92502 15.9999 4.17002 15.9999 4.45002V13.55C15.9999 13.83 15.8949 14.075 15.6849 14.285C15.4749 14.495 15.2299 14.6 14.9499 14.6H3.04999ZM8.99996 9.21001C9.0583 9.21001 9.10788 9.20126 9.14871 9.18376C9.18955 9.16626 9.2333 9.14584 9.27996 9.12251L14.7749 5.53502C14.8333 5.50002 14.877 5.45335 14.9062 5.39502C14.9354 5.33669 14.9499 5.27252 14.9499 5.20252C14.9499 5.05085 14.8829 4.93127 14.7487 4.84377C14.6145 4.75627 14.4774 4.75919 14.3374 4.85252L8.99996 8.26501L3.67999 4.85252C3.53999 4.75919 3.39999 4.75335 3.25999 4.83502C3.11999 4.91669 3.04999 5.03335 3.04999 5.18502C3.04999 5.25502 3.06749 5.3221 3.10249 5.38627C3.13749 5.45043 3.17833 5.50002 3.22499 5.53502L8.71997 9.12251C8.76663 9.14584 8.81038 9.16626 8.85122 9.18376C8.89205 9.20126 8.94163 9.21001 8.99996 9.21001Z'
        fill='currentColor'
      />
    </svg>
  );
};

/** 三角箭头 */
export const IconTriangleArrow: IconFC = ({ width = 6, height = 5, fill = '#F0F2F5' }) => {
  return (
    <svg width={width} height={height} viewBox='0 0 6 5' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M2.60687 3.85625L0.225618 1.475C0.0506179 1.3 0.00999265 1.09688 0.103743 0.865629C0.197493 0.634378 0.369368 0.518753 0.619368 0.518753H5.38187C5.63187 0.518753 5.80374 0.634378 5.89749 0.865629C5.99124 1.09688 5.95062 1.3 5.77562 1.475L3.39437 3.85625C3.33187 3.91875 3.26937 3.9625 3.20687 3.9875C3.14437 4.0125 3.07562 4.025 3.00062 4.025C2.92562 4.025 2.85687 4.0125 2.79437 3.9875C2.73187 3.9625 2.66937 3.91875 2.60687 3.85625Z'
        fill={fill}
      />
    </svg>
  );
};

/**
 * 信息
 * https://res.insta360.com/static/e33aa5c3f69420893898cf55e56bc278/20241129-160237.jpeg
 */
export const IconInfo: RectIconFC = ({ size = 16, fill = '#fff', ...rest }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 17 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...rest}>
      <circle cx='8.76641' cy='7.9998' r='6.8' stroke={fill} strokeWidth='0.8' />
      <path
        d='M8.50282 9.61462V9.61462C8.50282 8.94983 9.09363 8.43791 9.62673 8.04074C10.0696 7.71081 10.3553 7.19061 10.3553 6.60536C10.3553 5.60817 9.52587 4.7998 8.50282 4.7998C7.47977 4.7998 6.65039 5.60817 6.65039 6.60536'
        stroke={fill}
        strokeWidth='1.2'
        strokeLinecap='round'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.49922 12.3998C8.94104 12.3998 9.29922 12.0416 9.29922 11.5998C9.29922 11.158 8.94104 10.7998 8.49922 10.7998C8.05739 10.7998 7.69922 11.158 7.69922 11.5998C7.69922 12.0416 8.05739 12.3998 8.49922 12.3998Z'
        fill={fill}
      />
    </svg>
  );
};

/**
 * 完成
 * https://res.insta360.com/static/c2641aea5b81a5a877c0f800eaa4df10/WechatIMG66.jpg
 */
export const IconDone: RectIconFC = ({ size = 24, fill = '#22C55E', ...rest }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...rest}>
      <circle cx='12' cy='12' r='12' fill={fill} />
      <g clipPath='url(#clip0_15950_16211)'>
        <path
          d='M7.5 12.3L10.7 15.6L17.1 9'
          stroke='white'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_15950_16211'>
          <rect width='12' height='12' fill='white' transform='translate(6 6)' />
        </clipPath>
      </defs>
    </svg>
  );
};

/**
 * 过滤
 * https://res.insta360.com/static/d6a7b88ac949442e870f34da4c526fc9/Filter.jpg
 */
export const IconFilter: IconFC = ({
  width = 16,
  height = 16,
  fill = '#27272A',
  d = 'M4.04346 2C3.21153 2 2.74337 2.95666 3.25383 3.61358L6.5 7.79113V12.7117C6.5 12.8839 6.61017 13.0367 6.77351 13.0912L8.97351 13.8245C9.23252 13.9108 9.5 13.7181 9.5 13.445V7.74662C9.5 7.65556 9.53107 7.56723 9.58807 7.49622L12.6948 3.62599C13.2202 2.97149 12.7542 2 11.915 2H4.04346Z',
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path d={d} stroke={fill} strokeWidth='1.33333' strokeLinejoin='round' />
    </svg>
  );
};

/**
 * 选中依附在按钮上的Icon
 * https://res.insta360.com/static/6c785327d8f518b2298b417555edde0d/IconSelected.jpeg
 */
export const IconSelected: RectIconFC = ({ size = 16, fill = '#27272A', ...rest }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...rest}>
      <path d='M0 0H11C13.7614 0 16 2.23858 16 5V16H6C2.68629 16 0 13.3137 0 10V0Z' fill={fill} />
      <rect width='16' height='16' fill='white' fillOpacity='0.01' />
      <path d='M11.0129 5.01293L5.00508 11.0051' stroke='white' strokeLinecap='round' />
      <path d='M5.00045 4.99972L11.0004 10.9997' stroke='white' strokeLinecap='round' />
    </svg>
  );
};

export default {
  ArrowTop,
  ArrowBottom,
  ArrowRight,
  ArrowLeft,
  IconClose,
  IconSearch,
  IconCorrect,
  IconCloseCircle,
  IconArrowDown,
  IconPlus,
  IconMinus,
  IconLeftArrow,
  IconRightArrow,
  IconFilter,
  IconSelected,
};

export const OSSICON = {
  cart: 'https://res.insta360.com/static/68cdf1835062fffc926a88865040f754/cartIcon.svg',
  ring: 'https://res.insta360.com/static/97be2dddf3719f09bd9c09af338c6570/ring.svg',
  addToCart:
    'https://res.insta360.com/static/0166f1ce405e1e60f09d5f2f5cbb6138/add_shopping_cart_black_24dp%E5%A4%87%E4%BB%BD.svg',
  redWarning: 'https://res.insta360.com/static/79935d7183a4573531440a71a807c13b/%E6%88%90%E5%8A%9F.svg',
};
